export const ENDPOINT =
	window.signupendpoint ||
	"http://localhost:8080/api/account/trial_signup";
export const IP_ENDPOINT = "https://ipinfo.io/json";
export const COOKIE_REFERRAL = "velpic_trialreferralcode";
export const COOKIE_HS = "hubspotutk";
export const HS_PORTAL = 2386497;
export const HS_FORM_ENDPOINT = formID =>
	`https://forms.hubspot.com/uploads/form/v2/${HS_PORTAL}/${formID}`;
export const HS_SIGNUP_FORM = HS_FORM_ENDPOINT(
	"4c3ea00b-9f67-464f-868d-7c3bb7bbb647"
);

export const ERROR_CODES = {
	MISSING_PARAMETER: 800,
};

export const INPUT_NAMES = {
	referral: "referral",
	firstName: "firstname",
	lastName: "lastname",
	name: "name",
	email: "email",
	company: "company",
	tmz: "tmz",
	phoneNumber: "phonenumber",
	recaptcha: "recaptcha",
	tenantId: "tenantId",
    tenantAdminId: "tenantAdminId",
};

export const GOOGLE_RECPATCHA_SITE_KEY = "6LcEwwkeAAAAAFV46XZUR12VdRU2V8dA2Ign_OyA"
